import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const LOGO_URL = '/logomedusanewupdate.png';

export const Loader = ({ onLoadComplete }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => {
        onLoadComplete && onLoadComplete();
      }, 500);
    }, 2500);

    return () => clearTimeout(timer);
  }, [onLoadComplete]);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          data-testid="loader-container"
          className="fixed inset-0 z-[9999] flex items-center justify-center"
          style={{ backgroundColor: 'black' }}
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5, ease: 'easeOut' }}
        >
          <div className="flex flex-col items-center">
            {/* Animated Logo with shadow/sepia effect */}
            <motion.div
              className="relative"
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{
                scale: [0.8, 1, 0.95, 1],
                opacity: 1
              }}
              transition={{
                duration: 0.8,
                ease: 'easeOut'
              }}
            >
              {/* Breathing animation */}
              <motion.img
                src={LOGO_URL}
                alt="MALABISthestic"
                className="w-32 h-32 md:w-48 md:h-48 object-contain"
                style={{ filter: 'none',
                   
                 }}
                animate={{
                  scale: [1, 1.05, 1],
                }}
                transition={{
                  duration: 2,
                  ease: 'easeInOut',
                  repeat: Infinity,
                }}
              />
              
              {/* White ring effect */}
              <motion.div
                className="absolute inset-0 rounded-full"
                style={{
                  border: '1px solid #ffffff',
                  opacity: 0
                }}
                animate={{
                  scale: [1, 1.5, 2],
                  opacity: [0.6, 0.3, 0],
                }}
                transition={{
                  duration: 2,
                  ease: 'easeOut',
                  repeat: Infinity,
                }}
              />
            </motion.div>

            {/* Brand name */}
            <motion.div
              className="mt-8 text-center"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5, duration: 0.6 }}
            >
              <h1
                className="text-xl md:text-2xl lg:text-3xl tracking-wider md:tracking-widest text-center"
                style={{
                  fontFamily: 'Bodoni Moda, serif',
                  color: 'white'
                }}
              >
                MALABIS<span>theistic</span>
              </h1>
              <motion.div
                className="mt-4 mx-auto"
                style={{
                  width: '60px',
                  height: '1px',
                  background: 'linear-gradient(90deg, transparent, white, transparent)'
                }}
                animate={{
                  width: ['60px', '100px', '60px']
                }}
                transition={{
                  duration: 2,
                  repeat: Infinity,
                  ease: 'easeInOut'
                }}
              />
            </motion.div>

            {/* Loading text */}
            <motion.p
              className="mt-6 text-xs uppercase tracking-widest"
              style={{
                fontFamily: 'Manrope, sans-serif',
                color: 'white'
              }}
              initial={{ opacity: 0 }}
              animate={{ opacity: [0.5, 1, 0.5] }}
              transition={{ duration: 1.5, repeat: Infinity }}
            >
              Elegance in Uniformity
            </motion.p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Loader;
